export interface IBuildConfiguration {
  companyName: string;
  productName: string;
  productVersion: string;
  dataUrl: string;
  codeUrl: string;
  frameworkUrl: string;
  streamingAssetsUrl?: string;
}

export const defaultConfig: IBuildConfiguration = {
  companyName: 'Synaptikon GmbH.',
  productName: 'NeuroNation BrainTraining',
  productVersion: '3.0.2',
  dataUrl: 'Production.data',
  codeUrl: 'Production.wasm',
  frameworkUrl: 'Production.framework.js',
};

export function getConfig(
  prefixPath: string,
  dataUrlOverride?: string,
  codeUrlOverride?: string,
  frameworkUrlOverride?: string
) {
  const dataUrl = dataUrlOverride || defaultConfig.dataUrl;
  const codeUrl = codeUrlOverride || defaultConfig.codeUrl;
  const frameworkUrl = frameworkUrlOverride || defaultConfig.frameworkUrl;
  const updatedConfig: IBuildConfiguration = {
    ...defaultConfig,
    dataUrl: `${prefixPath}/${dataUrl}`,
    codeUrl: `${prefixPath}/${codeUrl}`,
    frameworkUrl: `${prefixPath}/${frameworkUrl}`,
  };
  return updatedConfig;
}

export type ProgressCallback = (progress: number) => void;

export interface IUnityInstance {
  SetFullscreen: (fullscreen: EFullscreenMode) => void;
  SendMessage: (objectName: string, methodName: string, value?: string | number) => void;
  Quit: () => Promise<void>;
  // for now we are not sure if this context is always defined
  audioContext?: AudioContext;
}

/**
 * trackEvent callback structure (comes in JSON)
 * {"end_Unity_FPS": 29, "end_avg_Unity_FPS": 30}
 */
export interface IUnityEventData {
  [eventKey: string]: number;
}

export enum EFullscreenMode {
  Off = 0,
  On = 1,
}
